import React from 'react';

export default function PrivacyPage() {
  const sections = [
    {
      h: '1. हम कौन-सी जानकारी लेते हैं',
      p: 'जब आप हमारी वेबसाइट पर फॉर्म भरते हैं, तो हम आपका नाम, मोबाइल नंबर, ईमेल और आपकी बताई गई समस्या का विवरण लेते हैं। यह जानकारी आप स्वेच्छा से हमें देते हैं ताकि हम आपकी सहायता कर सकें।',
    },
    {
      h: '2. जानकारी का उपयोग',
      p: 'आपकी दी गई जानकारी का उपयोग केवल आपकी समस्या के समाधान, रिपोर्ट तैयार करने, परामर्श (consultation) की सुविधा देने, तथा आपसे संपर्क करने (WhatsApp, कॉल या ईमेल के माध्यम से) के लिए किया जाता है।',
    },
    {
      h: '3. WhatsApp संदेश',
      p: 'फॉर्म भरने के बाद आपको WhatsApp पर पुष्टि (confirmation) एवं आपकी रिपोर्ट से संबंधित utility संदेश भेजे जा सकते हैं। ये संदेश केवल आपकी सेवा से जुड़ी जानकारी के लिए होते हैं। आप किसी भी समय "STOP" लिखकर इन्हें बंद करवा सकते हैं।',
    },
    {
      h: '4. ईमेल संदेश',
      p: 'आपको आपकी रिपोर्ट, परामर्श ऑफर और सेवा से जुड़े ईमेल भेजे जा सकते हैं। हर ईमेल में unsubscribe का विकल्प मौजूद होता है जिससे आप कभी भी इन्हें बंद कर सकते हैं।',
    },
    {
      h: '5. जानकारी की सुरक्षा',
      p: 'आपकी व्यक्तिगत जानकारी सुरक्षित रखी जाती है और इसे किसी तीसरे पक्ष (third party) को बेचा या साझा नहीं किया जाता। जानकारी केवल हमारी सेवा-दल टीम तक सीमित रहती है।',
    },
    {
      h: '6. भुगतान',
      p: 'सभी भुगतान सुरक्षित payment gateway (Razorpay) के माध्यम से होते हैं। हम आपके कार्ड/बैंक की कोई गोपनीय जानकारी संग्रहित नहीं करते।',
    },
    {
      h: '7. आपके अधिकार',
      p: 'आप किसी भी समय अपनी जानकारी हटवाने, संदेश बंद करवाने या अपनी जानकारी देखने का अनुरोध कर सकते हैं। इसके लिए नीचे दिए नंबर पर संपर्क करें।',
    },
    {
      h: '8. संपर्क',
      p: 'किसी भी प्रश्न या अनुरोध के लिए हमारी सेविका से संपर्क करें: 📞 +91 92411 65807',
    },
  ];

  return (
    <div className="min-h-screen bg-[#0B0B0E] py-12 px-4" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <img src="/mata-profile.jpg" alt="माता मलिहा जी" className="w-20 h-20 rounded-full border-4 border-[#C9A23A] mx-auto mb-4 shadow-lg" />
          <h1 className="text-3xl sm:text-4xl font-black text-[#E2C170] mb-2" style={{ fontFamily: "'Rozha One', serif" }}>
            गोपनीयता नीति (Privacy Policy)
          </h1>
          <p className="text-[#8a8578] text-sm">माता मलिहा सेवा दल · अंतिम अद्यतन: जुलाई 2026</p>
        </div>

        <div className="space-y-6">
          {sections.map((s, i) => (
            <div key={i} className="p-5 rounded-xl bg-[#17171C] border border-[#d4a84b]/25" data-testid={`privacy-section-${i}`}>
              <h2 className="text-[#E2C170] font-bold text-lg mb-2">{s.h}</h2>
              <p className="text-[#D8D2C6] text-sm leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-[#F3EDE2] text-sm mt-10">❖ जय माता मलिहा ❖</p>
      </div>
    </div>
  );
}
